export default __webpack_public_path__ + "static/media/AboutBox.f17a6ceb.jpg";